module.exports = __webpack_public_path__ + "static/network-increase-f49e7561f22b3afc4dc336c9b9379367.svg";